import React from 'react';
import TablaSolicitudUrbanizacion from './Tablas/TablaSolicitudUrbanizacion';
import GraficoSolicitudUrbanizacion from './Graficos/GraficoSolicitudUrbanizacion';

import { VStack, Heading } from '@chakra-ui/react';
import ObrasUrbanizacionDashboard from './Dashboard/ObrasUrbanizacionDashboard';

const ObrasUrbanizacion: React.FC = () => {
  return (
    <VStack spacing={8} align="stretch">
      <Heading size="lg" textAlign="center" color="wine.700">
        Urbanizacion
      </Heading>
      <ObrasUrbanizacionDashboard/>
      <TablaSolicitudUrbanizacion />
    </VStack>
  );
};

export default ObrasUrbanizacion;
